import { Stack, StackProps } from '@mui/material';
import { ReactNode } from 'react';
import { BORDER_COLOR, MAIN_BOX_SHADOW } from 'utils/theme';

interface Props extends StackProps {
  children: ReactNode;
  highlightOnHover?: boolean;
}

const Card = ({ children, highlightOnHover, sx, ...props }: Props) => {
  return (
    <Stack
      bgcolor="white"
      overflow="hidden"
      border={`1px solid ${BORDER_COLOR}`}
      borderRadius="12px"
      boxShadow={MAIN_BOX_SHADOW}
      sx={{
        transition: 'border 0.3s, box-shadow 0.3s',
        border: `1px solid ${BORDER_COLOR}`,
        '&:hover, &:focus-within': {
          border: highlightOnHover
            ? `1px solid color-mix(in srgb, ${BORDER_COLOR} 80%, black)`
            : `1px solid ${BORDER_COLOR}`,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default Card;
